import { useMemo } from "react";
import { useAuthContext } from "../context/AuthContext/AuthContext";

export const useProductCategoryFilter = (): string[] | undefined => {
  const authCtx = useAuthContext();

  const categoryFilter = useMemo(() => {
    if (!authCtx.isAuthenticated || !authCtx.user) {
      return undefined;
    }

    const showCategories = authCtx.user.showCategories;
    
    if (!showCategories || showCategories.length === 0) {
      return undefined;
    }

    const categoryIds = showCategories
      .filter(cat => cat && cat.databaseId != null)
      .map(cat => cat.databaseId.toString());
    
    return categoryIds.length > 0 ? categoryIds : undefined;
  }, [
    authCtx.isAuthenticated,
    authCtx.user?.showCategories,
  ]);

  return categoryFilter;
}; 